import { InjectableRxStompConfig } from '@stomp/ng2-stompjs';
import { environment } from './src/environments/environment';

export const stompConfig: InjectableRxStompConfig = {
  // Which server?
  brokerURL: environment.production
    ? `wss://${window.location.hostname}/ws`
    : `wss://fusion-ctl-10.ral.ds.jdsu.net/ws`,
  // Headers
  // Typical keys: login, passcode, host
  connectHeaders: {
    login: 'none',
    passcode: 'none'
  },

  // How often to heartbeat?
  // Interval in milliseconds, set to 0 to disable
  heartbeatIncoming: 0, // Typical value 0 - disabled
  heartbeatOutgoing: 20000, // Typical value 20000 - every 20 seconds

  // Wait in milliseconds before attempting auto reconnect
  // Set to 0 to disable
  // Typical value 5000 (5 seconds)
  reconnectDelay: 5000,

  // Will log diagnostics on console
  // eslint-disable-next-line
  debug: (msg): void => {
    //console.log('msg:', msg);
  }
};
